// src/components/FlashcardList.js
import React, { useState } from 'react';
import Flashcard from './Flashcard';
import './FlashcardList.css';

const flashcardSets = {
  set1: [
  { 
    word: "helpful", 
    definition: "giving assistance or support", 
    example_sentence: "The guide was very helpful when we were lost." 
  },
  { 
    word: "confuse", 
    definition: "to make someone unable to think clearly", 
    example_sentence: "The instructions confused the new students." 
  },
  { 
    word: "rare", 
    definition: "not happening very often", 
    example_sentence: "Seeing a rainbow at night is very rare." 
  },
  { 
    word: "predict", 
    definition: "to say what will happen in the future", 
    example_sentence: "The teacher predicted the test would be difficult." 
  },
  { 
    word: "share", 
    definition: "to give part of something to someone else", 
    example_sentence: "He shared his snacks with his friends." 
  },
  { 
    word: "strong", 
    definition: "having great power or energy", 
    example_sentence: "She is strong enough to lift heavy boxes." 
  },
  { 
    word: "protect", 
    definition: "to keep someone or something safe", 
    example_sentence: "The fence protects the garden from animals." 
  },
  { 
    word: "discover", 
    definition: "to find something for the first time", 
    example_sentence: "They discovered an old map in the attic." 
  },
  { 
    word: "usual", 
    definition: "normal or expected", 
    example_sentence: "She woke up at her usual time of 6 a.m." 
  },
  { 
    word: "reduce", 
    definition: "to make something smaller or less", 
    example_sentence: "We should reduce the amount of plastic we use." 
  },
  { 
    word: "quick", 
    definition: "fast or happening in a short time", 
    example_sentence: "The quick fox dashed across the field." 
  },
  { 
    word: "simple", 
    definition: "easy to understand or do", 
    example_sentence: "The game rules were simple to follow." 
  },
  { 
    word: "detail", 
    definition: "a small part of something", 
    example_sentence: "She noticed every detail in the drawing." 
  },
  { 
    word: "improve", 
    definition: "to make something better", 
    example_sentence: "He practiced daily to improve his writing." 
  },
  { 
    word: "continue", 
    definition: "to keep doing something", 
    example_sentence: "The rain continued throughout the afternoon." 
  },
  { 
    word: "measure", 
    definition: "to find the size or amount of something", 
    example_sentence: "They used a ruler to measure the table." 
  },
  { 
    word: "honest", 
    definition: "telling the truth", 
    example_sentence: "She was honest about losing the book." 
  },
  { 
    word: "copy", 
    definition: "to make something look exactly the same", 
    example_sentence: "He tried to copy the dance moves perfectly." 
  },
  { 
    word: "calm", 
    definition: "relaxed and not excited or upset", 
    example_sentence: "He stayed calm during the storm." 
  },
  { 
    word: "traditional", 
    definition: "following old customs or beliefs", 
    example_sentence: "They wore traditional clothes for the festival." 
  },
  { 
    word: "superficial", 
    definition: "concerned only with the obvious; not deep", 
    example_sentence: "Her understanding of the topic was superficial." 
  },
  { 
    word: "refine", 
    definition: "to improve by making small changes", 
    example_sentence: "He refined his essay before submitting it." 
  },
  { 
    word: "sustain", 
    definition: "to maintain or keep going", 
    example_sentence: "The athlete sustained his energy through the long race." 
  },
  { 
    word: "calculate", 
    definition: "to determine by reasoning or mathematics", 
    example_sentence: "She calculated the total cost of her groceries." 
  },
  { 
    word: "lucrative", 
    definition: "producing a large profit", 
    example_sentence: "Selling handmade jewelry turned into a lucrative business." 
  },
  { 
    word: "authentic", 
    definition: "genuine; real", 
    example_sentence: "They enjoyed the restaurant’s authentic Thai dishes." 
  },
  { 
    word: "mediate", 
    definition: "to help settle a dispute", 
    example_sentence: "The teacher mediated the argument between the students." 
  },
  { 
    word: "conventional", 
    definition: "based on what is traditionally done", 
    example_sentence: "She preferred a conventional approach to teaching." 
  }
],

  set2: [
  { 
    word: "emerge", 
    definition: "to come into view or become visible", 
    example_sentence: "The sun began to emerge from behind the clouds." 
  },
  { 
    word: "vivid", 
    definition: "producing strong, clear, and striking images in the mind", 
    example_sentence: "Her vivid description made me feel like I was actually there." 
  },
  { 
    word: "reluctant", 
    definition: "unwilling or hesitant to do something", 
    example_sentence: "He was reluctant to speak in front of the class." 
  },
  { 
    word: "significant", 
    definition: "important or meaningful", 
    example_sentence: "Winning the award was a significant moment in her life." 
  },
  { 
    word: "venture", 
    definition: "to go on a risky or daring journey", 
    example_sentence: "They decided to venture into the forest despite the warning signs." 
  },
  { 
    word: "fragrant", 
    definition: "having a pleasant smell", 
    example_sentence: "The garden was full of fragrant flowers." 
  },
  { 
    word: "anticipate", 
    definition: "to expect or look forward to something", 
    example_sentence: "The team eagerly anticipated the final match." 
  },
  { 
    word: "dreary", 
    definition: "dull, bleak, and lifeless", 
    example_sentence: "The weather was dreary and made everyone feel tired." 
  },
  { 
    word: "convey", 
    definition: "to communicate or make known", 
    example_sentence: "She used pictures to convey her ideas clearly." 
  },
  { 
    word: "elaborate", 
    definition: "involving many careful details or complicated parts", 
    example_sentence: "The wedding decorations were elaborate and stunning." 
  },
  { 
    word: "benevolent", 
    definition: "well-meaning and kindly", 
    example_sentence: "The benevolent teacher always looked out for her students." 
  },
  { 
    word: "feeble", 
    definition: "lacking strength or effectiveness", 
    example_sentence: "His feeble attempt at lifting the box made everyone laugh." 
  },
  { 
    word: "conspicuous", 
    definition: "clearly visible or attracting attention", 
    example_sentence: "The bright red umbrella was conspicuous in the crowd." 
  },
  { 
    word: "diligent", 
    definition: "showing care and effort in work or duties", 
    example_sentence: "She was a diligent student who always completed her assignments on time." 
  },
  { 
    word: "hinder", 
    definition: "to create difficulties for someone or something", 
    example_sentence: "The heavy rain will hinder construction progress." 
  },
  { 
    word: "meticulous", 
    definition: "showing great attention to detail", 
    example_sentence: "The artist was meticulous in painting each stroke." 
  },
  { 
    word: "resilient", 
    definition: "able to recover quickly from difficulties", 
    example_sentence: "Children can be remarkably resilient after challenges." 
  },
  { 
    word: "spontaneous", 
    definition: "performed or occurring without planning", 
    example_sentence: "They decided to take a spontaneous trip to the beach." 
  },
  { 
    word: "tedious", 
    definition: "too long, slow, or dull; tiresome", 
    example_sentence: "Filling out forms can be a tedious process." 
  },
  { 
    word: "versatile", 
    definition: "able to adapt to many different functions or activities", 
    example_sentence: "The versatile actor could play both comedic and serious roles." 
  }
]


};

const FlashcardList = () => {
  const [currentSet, setCurrentSet] = useState('set1');
  const [testMode, setTestMode] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [rememberedCount, setRememberedCount] = useState(0);

  const handleRemembered = () => {
    setRememberedCount(rememberedCount + 1);
    nextFlashcard();
  };

  const nextFlashcard = () => {
    if (currentIndex < flashcardSets[currentSet].length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      alert(`Test complete! You remembered ${rememberedCount + 1} out of ${flashcardSets[currentSet].length} words.`);
      setTestMode(false);
      setCurrentIndex(0);
      setRememberedCount(0);
    }
  };

  return (
    <div>
      <select onChange={(e) => setCurrentSet(e.target.value)} value={currentSet} disabled={testMode}>
        <option value="set1">Set 1</option>
        <option value="set2">Set 2</option>
        <option value="set3">Set 3</option>
      </select>
      <button onClick={() => setTestMode(!testMode)}>
        {testMode ? 'Exit Test Mode' : 'Enter Test Mode'}
      </button>
      <div className="flashcard-list">
        {testMode ? (
          <div>
            <Flashcard 
              word={flashcardSets[currentSet][currentIndex].word} 
              definition={flashcardSets[currentSet][currentIndex].definition} 
              example_sentence={flashcardSets[currentSet][currentIndex].example_sentence} 
            />
            <button onClick={handleRemembered}>Remembered</button>
            <button onClick={nextFlashcard}>Next</button>
          </div>
        ) : (
          flashcardSets[currentSet].map((flashcard, index) => (
            <Flashcard key={index} word={flashcard.word} definition={flashcard.definition} example_sentence={flashcard.example_sentence} />
          ))
        )}
      </div>
    </div>
  );
};

export default FlashcardList;